interface AppConfig {
  title: string;
  website: string;
  helpline: string;
  description: string;
  head: {
    titleTemplate: string;
    meta: {
      name?: string;
      charset?: string;
      property?: string;
      content?: string;
    }[];
  };
}

interface Configs {
  app: AppConfig;
  isProduction: boolean;
}

const environment = {
  development: {
    isProduction: false,
  },
  production: {
    isProduction: true,
  },
}[process.env.NODE_ENV || "development"];

const configs: Configs = {
  app: {
    title: "QJumpers",
    website: "http://qjumpers.com",
    helpline: "0800 758 673",
    description: "QJumpers Recruitment",
    head: {
      titleTemplate: "%s - QJumpers",
      meta: [
        { name: "description", content: "QJumpers Recruitment" },
        { charset: "utf-8" },
        { property: "og:site_name", content: "QJumpers Recruitment" },
        { property: "og:image", content: "" },
        { property: "og:locale", content: "en_US" },
        { property: "og:title", content: "QJumpers Recruitment" },
        { property: "og:description", content: "QJumpers Recruitment" },
        { property: "og:card", content: "summary" },
        { property: "og:site", content: "@QJumpers" },
        { property: "og:creator", content: "QJumpers" },
        { property: "og:image:width", content: "200" },
        { property: "og:image:height", content: "200" },
      ],
    },
  },
  ...environment!,
};

export default configs;
